/**
 * Monaco theme selection.
 *
 * The editor renders with GitHub Dark / GitHub Light, ported from GitHub's
 * official VS Code themes. Monaco ships only `vs`, `vs-dark`, `hc-black` and
 * `hc-light`, so these are custom ids that `loader.ts` must register with
 * `defineTheme` before `setTheme` will resolve them — see `githubTheme.ts` for
 * the palette and `scripts/generate-github-monaco-theme.ts` for how it is
 * produced.
 *
 * Monaco's theme is page-global (`StandaloneThemeService` holds a single
 * `_theme`, and the syntax colours it emits are unscoped `.mtk*` CSS rules),
 * which is why there is no per-instance theme prop anywhere in this entry —
 * such an API would let one editor silently restyle another.
 */
export const MONACO_THEME_ID = {
  dark: 'github-dark',
  light: 'github-light',
} as const;

export type { MonacoThemeMode } from './githubTheme';
export { githubMonacoTheme } from './githubTheme';
